/// <reference path="./prestige-connector-api.js" />
// @ts-check
class PrestigeCurrentBalance extends PrestigeBaseElement {
    onConnected() {
      this.store.profile.load();
    }

    dependencies() {
      return [this.store.profile];
    }

    errorMessage(message) {
      const errorDiv = document.createElement('div');
      errorDiv.classList.add('error-message', 'text-red-500', 'text-sm', 'mt-4', 'absolute', 'top-full');
      errorDiv.innerHTML = message;
      this.insertAdjacentElement('afterend', errorDiv);
    }

    render() {
      const profile = this.store.profile;

      if (!profile || !profile.data) {
        this.errorMessage('<p>Unable to fetch profile.</p>');
        return this._initialContent || '';
      }

      const { data, errors } = profile;

      if (errors?.length > 0) {
        const errorHtml = this.html`<ul>${errors.map(error => `<li>${error}</li>`)}</ul>`;
        this.errorMessage(errorHtml);
        return this._initialContent || '';
      }

      const prestigeAccount = data.accounts.find(acc => acc.id === 'prestige_balance');
      const currentTier = data.tiers[0];

      if (!prestigeAccount) {
        this.errorMessage('<p>No prestige balance account found.</p>');
        return this._initialContent || '';
      }

      if (!currentTier) {
        this.errorMessage('<p>No tier found.</p>');
        return this._initialContent || '';
      }

      const nextPoints = currentTier.next?.points || currentTier.threshold;
      const currentPoints = currentTier.points;
      const pointsUntilNext = nextPoints;

      let pointsExpiryDate = '';
      let expiryDate = null;

      if (data.properties?.point_expiration_date) {
        expiryDate = new Date(data.properties.point_expiration_date);
      } else if (data.optin_at) {
        expiryDate = new Date(data.optin_at * 1000);
        expiryDate.setFullYear(expiryDate.getFullYear() + 1);
      }

      if (expiryDate) {
        pointsExpiryDate = expiryDate.toLocaleDateString('en-GB', {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
        });
      }

      return this.mount({
        balance: prestigeAccount.spendable,
        pending: prestigeAccount.pending,
        current_tier: currentTier.name,
        current_tier_points: currentPoints,
        next_tier_points: nextPoints,
        points_until_next: `+ ${pointsUntilNext}`,
        lifetime_points: currentPoints,
        points_expiry_date: pointsExpiryDate,
      });
    }

}
customElements.define('prestige-current-balance', PrestigeCurrentBalance);
